import logo from './logo.svg';
import './App.css';
import Navbar from './components/pages/Navbar'
import Footer from './components/pages/Footer';
import ReactGa from 'react-ga';
import React, { useEffect, useState, useRef} from 'react' 
import '../src/components/pages/AuthContext'; // Garanta que i18n é importado
import { AuthProvider } from './components/pages/AuthContext';
import { PopupProvider } from './components/pages/hooks/PopupContext';
import { LanguageProvider, useLanguage } from './components/pages/LanguageContext'; 
import CookieBanner from './components/pages/CookieBanner';
import '@flaticon/flaticon-uicons/css/all/all.css';
function App() {
 useEffect(() =>{
  ReactGa.initialize('G-6GFTR9EKYT')
  
  //to report page view 
  ReactGa.pageview(window.location.pathname + window.location.search)
 }, []);

  useEffect(() => {
    window.googleTranslateElementInit = () => {
      if (window.google) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: 'pt',
            includedLanguages: 'en,es,fr,it,zh-CN',
          },
          'google_translate_element'
        );
      }
    };

    const script = document.createElement('script');
    script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
    <div id="google_translate_element"></div>
    <div className="notranslate">
    <LanguageProvider> {/* Envolvendo a aplicação com o LanguageProvider */}
    <AuthProvider>
    <Navbar />
     <PopupProvider></PopupProvider>
    <Footer />
    </AuthProvider>
    </LanguageProvider>
    <CookieBanner /> {/* Aqui fora do <footer> */}
   </div>

    </>
  )
}

export default App;



